// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import femonitorVue from 'femonitor-vue';
import { Select, Option } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
femonitorVue(Vue);
if (window.feMonitor) {
  feMonitor.setConfig({
    sampleRate: 1,
    ignorePerformancePattern: [/history/]
  });
}
import App from './pages/App';
// import router from './router'
// import Vuex from 'vuex'
// import axios from 'axios';
import util from '@/utils/util.js';
import rAF from '@/utils/rAF.js';
import project from '@/utils/project.js';
Vue.use(Select);
Vue.use(Option);
Vue.config.productionTip = false;
window.eventBus = new Vue();

// Vue.prototype.$http = axios;
window.$util = util;
Vue.prototype.$rAF = rAF;
Vue.prototype.$project = project;

const oldTA = TA.log;
TA.log = function() {
  const args = [].slice.call(arguments);
  rAF.rAF(() => {
    oldTA(...args);
  });
};
// Vue.use(Vuex)

/* eslint-disable no-new */
requestAnimationFrame(() => {
  new Vue({
    el: '#app',
    components: { App },
    template: '<App/>'
  });
});



// WEBPACK FOOTER //
// ./src/main.js